import MainLayout from "../components/layout/MainLayout";
import MainLayoutUser from "../components/layout/MainLayoutUser";
import MainLayoutAdmin from "../components/layout/MainLayoutAdmin";
import BannerStaticAlt from "../components/organisms/BannerStaticAlt";
import OurServiceGrid from "../components/organisms/OurServiceGrid";
import { useEffect } from "react";
import { useAuthStore } from "../store/useAuthStore";

export default function OurService() {
  const { accessToken, type } = useAuthStore();
  useEffect(() => {
    document.title = "TalentLink | Our Service";

    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute("content", "Halaman utama TalentLink");
    }
  }, []);

  const Layout =
    !accessToken
      ? MainLayout
      : type === "candidate"
        ? MainLayoutUser
        : type === "company"
          ? MainLayoutAdmin
          : MainLayout;

  return (

    <Layout>
      <BannerStaticAlt>
        {/* <h2 className="text-3xl md:text-5xl font-medium mb-4 md:w-3/4 lg:w-2/3 text-shadow">
          Our Service
        </h2> */}
      </BannerStaticAlt>
      <OurServiceGrid />
    </Layout>
  );
}
